import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Link } from "react-router-dom";

import img1 from "../image/IUr2yuVr9x-6167JqzI+aS._AC_SY575_.jpg";
import img2 from "../image/Q8v9o4v-I9-ons23014.jpg";
import img3 from "../image/dFAdeGTHUh-csn23a03.jpg";
import img4 from "../image/9RcsjMpyl-lr2941a-500x500.webp";


const featuredProducts = [
  { name: "Gemstone Diamond Ring – Elegant Sparkle with Precious", discountPrice: "9999", originalPrice: "10000", img: img1, Link: "/" },
  { name: "Elegant Green Gemstone and Diamond Necklace Set", discountPrice: "9999", originalPrice: "10000", img: img2, Link: "/" },
  { name: "Diamond & White Gold Necklace Set – Luxury Jewelry for Women", discountPrice: "9999", originalPrice: "10000", img: img3, Link: "/" },
  { name: "Elegant Women's Diamond Ring – Timeless Luxury & Sparkling Beauty", discountPrice: "9999", originalPrice: "10000", img: img4, Link: "/" },
  { name: "Elegant Women's Diamond Ring – Timeless Luxury & Sparkling Beauty", discountPrice: "9999", originalPrice: "10000", img: img4, Link: "/" },
  { name: "Elegant Women's Diamond Ring – Timeless Luxury & Sparkling Beauty", discountPrice: "9999", originalPrice: "10000", img: img4, Link: "/" },
  { name: "Elegant Women's Diamond Ring – Timeless Luxury & Sparkling Beauty", discountPrice: "9999", originalPrice: "10000", img: img4, Link: "/" },
  { name: "Elegant Women's Diamond Ring – Timeless Luxury & Sparkling Beauty", discountPrice: "9999", originalPrice: "10000", img: img4, Link: "/" },
  { name: "Elegant Women's Diamond Ring – Timeless Luxury & Sparkling Beauty", discountPrice: "9999", originalPrice: "10000", img: img4, Link: "/" },

];

function FeaturedProduct() {
  useEffect(() => {
    const cards = document.querySelectorAll(".featured-product-card");

    cards.forEach((card) => {
      const field = document.createElement("div");
      field.className = "featured-particles-field";
      card.appendChild(field);

      for (let i = 0; i < 25; i++) {
        const particle = document.createElement("div");
        particle.className = "featured-particle";
        particle.style.setProperty("--x", `${Math.random() * 200 - 100}px`);
        particle.style.setProperty("--y", `${Math.random() * 200 - 100}px`);
        particle.style.animation = `particleFloat ${1 + Math.random() * 2}s infinite ease-in-out`;
        particle.style.animationDelay = `${Math.random() * 2}s`;
        particle.style.left = `${Math.random() * 100}%`;
        particle.style.top = `${Math.random() * 100}%`;
        field.appendChild(particle);
      }
    });
  }, []);

  return (
    <div className="featured-product-slider-container px-1 mt-4 feature-product-new">
      <div className="featured-product-header position-relative overflow-hidden d-flex justify-content-between align-items-center p-2 mb-2">
        <div>
          <h5 className="fw-bold featured-product-text mb-0">FEATURED PRODUCTS</h5>
        </div>
        <div>
          <Link className="text-decoration-none fw-bold featured-product-text" to="">
            View all
          </Link>
        </div>

        {/* === Animated gold border spans === */}
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
      </div>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={15}
        autoplay={{
          delay: 1800,
          disableOnInteraction: false,
        }}
        loop={true}
        speed={1000}
        breakpoints={{
          320: { slidesPerView: 2 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 6 },
        }}
      >
        {featuredProducts.map((prod, index) => (
          <SwiperSlide key={index}>
            <Link to={prod.Link} className="text-decoration-none">
              <div className="featured-product-card tilt">
                <div className="img-box">
                  <img src={prod.img} alt={prod.name} />
                </div>

                {/* === Animated border spans === */}
                <span className="mannu-bhai"></span>
                <span className="mannu-bhai"></span>
                <span className="mannu-bhai"></span>
                <span className="mannu-bhai"></span>

                <div style={{lineHeight:"0.6"}}>
                  <p>
                    {prod.name.length > 18
                      ? prod.name.substring(0, 18) + "..."
                      : prod.name}
                  </p>

                  <div className="d-flex align-items-center">
                    <span className="fw-bold text-success">${prod.discountPrice}</span>
                    <span className="text-warning fw-bold text-decoration-line-through ms-3">
                      ${prod.originalPrice}
                    </span>
                  </div>
                </div>

              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default FeaturedProduct;
